import React from 'react';
import * as H from "history";
import withApiHandler, {ErrorHandler, InjectedApiHandlerProps} from "../components/hocs/WithApiHandler";
import withSystemState, {InjectedSystemStateProps} from "../components/hocs/WithSystemState";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {getSocialLinks} from "./EventsPage";
import "../sass/common.scss"
import {Formik} from "formik";
import * as yup from 'yup';
import * as firebase from "firebase/app";
import "firebase/auth";
import {toast} from "react-toastify";
import * as _ from "lodash";
import ReactGA from 'react-ga';
import Spinner from "react-bootstrap/Spinner";


interface LoginPageBaseProps{
    history: H.History;
}

type LoginPageProps = LoginPageBaseProps & InjectedApiHandlerProps & InjectedSystemStateProps

interface LoginPageState{
    submitType: string;
    loading: boolean;
}

const loginSchema = yup.object({
    email: yup.string().required(),
    password: yup.string().required(),
});

const registerSchema = yup.object({
    email: yup.string().required().email(),
    password: yup.string().required().min(6),
});

class LoginPage extends React.Component<LoginPageProps, LoginPageState> {

    state={
        submitType: "login",
        loading: false
    };

    componentDidMount(): void {
        if(this.props.systemState.token && this.props.systemState.token.length>0){
            this.props.history.push("/events");
        }
    }

    getSubmitMenu = (submitHandler:any) =>{
        if(this.state.submitType==="login"){
            let buttonContent = !this.state.loading ? <span>Login</span> : (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <span className="sr-only">Loading...</span>
                </>
            );
            return (
                <div>
                    <Button variant="primary" size="lg" disabled={this.state.loading} block onClick={submitHandler}>{buttonContent}</Button>
                    <div className={"text-link"}>Don't have an account? <a href="#!"  onClick={() => this.setState({submitType: "signup"})}>Create one now</a></div>
                </div>
            );
        }else{
            let buttonContent = !this.state.loading ? <span>Register</span> : (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <span className="sr-only">Loading...</span>
                </>
            );
            return(
                <div>
                    <Button variant="primary" size="lg" block disabled={this.state.loading} onClick={submitHandler}>{buttonContent}</Button>
                    <div className={"text-link"}>Already have an account? <a href="#!" onClick={() => this.setState({submitType: "login"})}>Login</a></div>
                </div>
            );
        }
    };

    submit = (formData:any) =>{
        if(this.state.submitType==="login"){
            this.setState({loading:true},()=>{
                firebase.auth().signInWithEmailAndPassword(formData.email, formData.password).then(()=>this.onSuccessEmailLoginRegister(formData.email)).catch(function(error) {
                    var errorMessage = error.message;
                    toast.error(errorMessage,{position: toast.POSITION.TOP_CENTER});
                });
            });
        }else{
            this.setState({loading:true},()=>{
                firebase.auth().createUserWithEmailAndPassword(formData.email, formData.password).then(()=>this.onSuccessEmailLoginRegister(formData.email)).catch(function(error) {
                    var errorMessage = error.message;
                    toast.error(errorMessage,{position: toast.POSITION.TOP_CENTER});
                });
            });
        }
    };

    onSuccessEmailLoginRegister = (email:string) =>{
        firebase.firestore().collection("users").doc(email).set({
            lastLogin: new Date()
        }).then(this.sendToEvents).catch(function(error) {
            console.error("Error writing document: ", error);
        }).finally(()=> {
            this.setState({loading: false});
        });
    };

    sendToEvents = () =>{
        ReactGA.event({
            category: "Accounts",
            action: "User has logged in",
        });
        this.props.updateToken("hello");
        this.props.history.push("events");
        ReactGA.pageview("/events");
    };

    render(){
        return(
            <Container className={"full-view"}>

                <Row className={"full-height"}>
                    <Col xs={12} md={6} lg={6}>
                    <div className={"page-title"}>
                        <div>When</div>
                        <div>Where</div>
                        <div>What</div>
                    </div>
                    <div className={"login-form app-form"}>
                        <Formik
                            validationSchema={this.state.submitType==="login"?loginSchema:registerSchema}
                            onSubmit={this.submit}
                            initialValues={{
                                email: '',
                                password: '',
                            }}
                        >
                            {({
                                  handleSubmit,
                                  handleChange,
                                  handleBlur,
                                  values,
                                  touched,
                                  isValid,
                                  errors,
                              }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} xs="12" controlId="validationEmail">
                                            <Form.Label className={"sr-only"}>enter Email</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="email"
                                                placeholder={"enter email"}
                                                value={values.email}
                                                onChange={handleChange}
                                                isInvalid={!!errors.email}
                                            />
                                            {this.state.submitType!=="singup"?null:
                                                <Form.Text className="text-muted">
                                                    We'll never share your email with anyone else.
                                                </Form.Text>}
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} xs="12" controlId="validationPassword">
                                            <Form.Label className={"sr-only"}>Enter Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                placeholder={"enter password"}
                                                value={values.password}
                                                onChange={handleChange}
                                                isInvalid={!!errors.password}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.password}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                    {this.getSubmitMenu(handleSubmit)}
                                </Form>
                            )}
                        </Formik>
                    </div>
                    {getSocialLinks()}
                    <div className={"copyright"}>
                        © 2019 Purveyors of Now LLC
                    </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withSystemState(withApiHandler(LoginPage,ErrorHandler.TOAST));